import api from '../api/axios';
import { StoryImagePlanTtsStepEntity } from '../types/entities';

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_API_URL || '';
const withBase = (path: string) => `${BASE}${path}`;

export const createStep = async (body: Partial<StoryImagePlanTtsStepEntity>) => {
  const res = await api.post(withBase(`/story-image-plan-tts-steps`), body);
  return res.data as StoryImagePlanTtsStepEntity;
};

export const getStepById = async (id: string) => {
  const res = await api.get(withBase(`/story-image-plan-tts-steps/${id}`));
  return res.data as StoryImagePlanTtsStepEntity;
};

export const getStepsByImagePlan = async (imagePlanId: string) => {
  const res = await api.get(withBase(`/story-image-plan-tts-steps/by-image-plan/${imagePlanId}`));
  return res.data as StoryImagePlanTtsStepEntity[];
};

export const updateStep = async (id: string, body: Partial<StoryImagePlanTtsStepEntity>) => {
  const res = await api.patch(withBase(`/story-image-plan-tts-steps/${id}`), body);
  return res.data as StoryImagePlanTtsStepEntity;
};

export const deleteStep = async (id: string) => {
  const res = await api.delete(withBase(`/story-image-plan-tts-steps/${id}`));
  return res.data as { deleted: boolean };
};

export const reorderSteps = async (imagePlanId: string, items: Array<{ id: string; orderIndex: number }>) => {
  const res = await api.post(withBase(`/story-image-plan-tts-steps/reorder/${imagePlanId}`), { items });
  return res.data as StoryImagePlanTtsStepEntity[];
};

const ttsStepsService = {
  createStep,
  getStepById,
  getStepsByImagePlan,
  updateStep,
  deleteStep,
  reorderSteps,
};

export default ttsStepsService;
